import {
  COMMUNITIES_LOAD_START,
  COMMUNITIES_LOAD_END,
  COMMUNITY_CREATE_START,
  COMMUNITY_CREATE_END,
  SELECT_COMMUNITY,
} from './types'

const defaultState = {
  entities: [],
  selected: null,
  isLoading: false,
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case COMMUNITIES_LOAD_START:
      return {...state, entities: [], isLoading: true}
    case COMMUNITIES_LOAD_END:
      return {...state, entities: [...action.payload], isLoading: false}
    case COMMUNITY_CREATE_START:
      return {...state, isLoading: true}
    case COMMUNITY_CREATE_END:
      return {...state, isLoading: false}
    case SELECT_COMMUNITY:
      return {...state, selected: action.payload}
    default:
      return state
  }
}
